import React from 'react';
import { Grid, Box, Typography, useMediaQuery, Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ScrollToTop from '../scroll-to-top/scrolltop';
import SimpleMobileScroll from '../mobile-nav-arrows/SimpleMobileScroll';
import MenuTabs from '../menutabs/menutabs';
import BG from 'assets/img/kabahagi_bg.webp';
import "./landing.css";

const Landing = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const matchesSm = useMediaQuery(theme.breakpoints.up('sm'));
  const matchesMd = useMediaQuery(theme.breakpoints.up('md'));
  const matchesLg = useMediaQuery(theme.breakpoints.up('lg'));

  // Determine the font size based on screen size
  const getFontSize = () => {
    if (matchesLg) return 'h3';
    if (matchesMd) return 'h4';
    if (matchesSm) return 'h5';
    return 'h6';
  };

  // Determine banner image size based on screen size
  const getBannerWidth = () => {
    if (isMobile) return 11; // Almost full width on mobile
    if (isTablet) return 8;
    if (matchesMd) return 6;
    return 6; // Large screens
  };

  return (
    <Box sx={{ width: '100%', minHeight: '100vh', bgcolor: 'background.default' }}>
        <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
          {/* Hero Section */}
          <Grid item xs={12}>
            <Box 
              display="flex" 
              flexDirection="column" 
              alignItems="center" 
              textAlign="center"
              sx={{ py: { xs: 2, sm: 3, md: 4 } }}
            >
              {/* Banner Image */}
              <Box 
                sx={{ 
                  width: { 
                    xs: '95%', 
                    sm: '85%', 
                    md: '70%', 
                    lg: '60%' 
                  },
                  maxWidth: '600px',
                  mb: { xs: 2, sm: 3, md: 4 }
                }}
              >
                <img 
                  className="ssddBanner responsive-banner" 
                  src={BG} 
                  alt='QC Kabahagi Center Banner'
                  style={{
                    width: '100%',
                    height: 'auto',
                    borderRadius: '20px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                  }}
                />
              </Box>
              
              {/* Welcome Text */}
              <Box 
                sx={{ 
                  px: { xs: 1, sm: 2, md: 3 },
                  maxWidth: '800px'
                }}
              >
                <Typography 
                  variant={getFontSize()} 
                  fontWeight="bold" 
                  className="text-color"
                  sx={{
                    lineHeight: { xs: 1.3, sm: 1.4, md: 1.5 },
                    fontSize: {
                      xs: '1.2rem',
                      sm: '1.5rem',
                      md: '2rem',
                      lg: '2.5rem'
                    }
                  }}
                >
                  Welcome to QC Kabahagi Center for Children with Disabilities
                </Typography>
              </Box>
            </Box>
          </Grid>
          
          {/* Menu Tabs Section */}
          <Grid item xs={12}>
            <Box sx={{ width: '100%' }}>
              <MenuTabs />
            </Box>
          </Grid>
        </Grid>
      <ScrollToTop />
            <SimpleMobileScroll />
    </Box>
  );
}

export default Landing;